import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { errorHandler } from "../../_utils";
import { store, type UserFormType } from "..";
import { setUserLoading, setUsers } from "../slices/userSlice";

export const getUsers = async (notify: MessageInstance) => {
  try {
    store.dispatch(setUserLoading(true));
    const response = await privateAPI.get("/user");
    if (response) {
      store.dispatch(setUserLoading(false));
      store.dispatch(setUsers(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setUserLoading(false));
    console.error("Get User Error:", error);
    errorHandler(error, notify);
  }
};

export const createUser = async (
  notify: MessageInstance,
  payload: UserFormType,
) => {
  try {
    store.dispatch(setUserLoading(true));
    const { data } = await privateAPI.post("/user/create-by-admin", payload);
    notify.success("User created successfully!");
    return data;
  } catch (error) {
    console.error("Create User Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setUserLoading(false));
  }
};

export const updateUser = async (
  notify: MessageInstance,
  payload: UserFormType,
) => {
  try {
    if (!payload.id) return;
    store.dispatch(setUserLoading(true));
    const { data } = await privateAPI.post(
      `/user/update-by-admin/${payload.id}`,
      payload,
    );
    notify.success("User updated successfully!");
    return data;
  } catch (error) {
    console.error("Update User Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setUserLoading(false));
  }
};

export const deleteUser = async (
  notify: MessageInstance,
  id: string,
  getData = false,
) => {
  try {
    store.dispatch(setUserLoading(true));
    const response = await privateAPI.delete(`/user/${id}`);
    if (response) {
      getData && (await getUsers(notify));
    }
    notify.success("User deleted successfully!");
    return response;
  } catch (error) {
    console.error("Delete User Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setUserLoading(false));
  }
};
